import React, { Component } from "react"
import { connect } from 'react-redux'
import {
    updateGR_ItemAction,
    updateGR_ItemAccountAssignmentAction,
    getDataReleaseOrderAction
} from '../../redux/actions/GRAction'

import {
    getPODetailOriginalAction,
} from '../../redux/actions/MainAction'
import {
    EVENT_GET_DETAIL_BOT_LOG
} from '../../configs/EventTypes'
import { msg } from "../Notifications/MsgBox"

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { Input, DatePicker } from "../core"

import moment from 'moment'
import { getDetailLogBOTAction } from "../../redux/actions/SearchAction"

const numeral = require('numeral')

class DetailBotLogModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            itemDetail: [],
            page: 0,
            rowsPerPage: 10,
            type: ''
        }
        
        window.emitter.addListener(EVENT_GET_DETAIL_BOT_LOG, this.setCurrentReleaseOrderModal.bind(this))
    }

    setCurrentReleaseOrderModal(object) {
        
        // this.setState({
        //     poNo: object.po_no,
        //     itemNo: object.itemNo,
        //     type: object.type,
        //     page: 0,
        //     rowsPerPage: 10,
        // })

        this.props.getDetailLogBOT(object.transaction_no).then(response => {
            
            this.setState({
                itemDetail: response.data
            })

        })


    }

    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }

    render() {

        const { poNo,
            itemNo,
            itemDetail,
            page,
            rowsPerPage,
        } = this.state

        return (
            <div className="modal fade sp-modal rrs-modal" id="DetailBotLogModal" tabIndex={-1} role="dialog" aria-labelledby="DetailBotLogModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="DetailBotLogModalLabel">BOT Run Detail</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="rrs-detail2">
                                <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content">
                                        <div className="rrs-detail-data sp-table-container" style={{ minWidth: '3000px' }}>

                                            <div className="row no-gutters sp-table-content" > 

                                                    <Table className="sp-table table rrs-table">
                                                        <TableHead>
                                                            <TableRow className="sp-table-header">
                                                                <TableCell className="th-table text-center">RRS Doc No</TableCell>
                                                                <TableCell className="th-table text-center">สถานะเอกสาร</TableCell>
                                                                <TableCell className="th-table text-center">Update Date</TableCell>
                                                                <TableCell className="th-table text-center">PO/Contract</TableCell>
                                                                <TableCell className="th-table text-center">Mat Doc No</TableCell>
                                                                <TableCell className="th-table text-center">IR FI Doc No</TableCell>
                                                                <TableCell className="th-table text-center">Vat Run No</TableCell>
                                                                <TableCell className="th-table text-center">MR Doc No</TableCell>
                                                                <TableCell className="th-table text-center">Trans Status Detail</TableCell>
                                                                <TableCell className="th-table text-center">Exception Type</TableCell>
                                                                <TableCell className="th-table text-center">Exception Detail</TableCell>
                                                                <TableCell className="th-table text-center">Warning Description</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {itemDetail && itemDetail.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                .map((datas, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell className="th-table text-center">{datas.doc_no}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.status_name}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.updatedate ? moment(datas.updatedate).format('DD/MM/YYYY') : ""}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.contract_new_po_no}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.mat_doc_no}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.ir_fi_doc_no}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.vat_run_no}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.mr_no}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.trans_status_detail}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.exception_type}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.exception_detail}</TableCell>
                                                                        <TableCell className="th-table text-left">{datas.warning_description}</TableCell>
                                                                    </TableRow>
                                                                ))}

                                                            {itemDetail.length == 0 && (
                                                                <TableRow >
                                                                    <TableCell colSpan="12" className="th-table text-center">No header log records found.</TableCell>
                                                                </TableRow>
                                                            )}

                                                        </TableBody>
                                                    </Table>
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                                        component="div"
                                                        count={itemDetail.length}
                                                        rowsPerPage={this.state.rowsPerPage}
                                                        page={this.state.page}
                                                        backIconButtonProps={{
                                                            'aria-label': 'previous page',
                                                        }}
                                                        nextIconButtonProps={{
                                                            'aria-label': 'next page',
                                                        }}
                                                        onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page")}
                                                        onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page", "rowsPerPage")}
                                                    />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    const { MainRedux } = state
    return {
        t_GR_ITEM: MainRedux.t_GR_ITEM,
        po_original: MainRedux.po_original,
        t_GR_ITEM_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_ITEM_ACCOUNT_ASSIGNMENT
    }
}

const mapDispatchToProps = dispatch => {
    return {
        //saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction))
        updateGR_Item: (data, index = "", fieldName = "") => dispatch(updateGR_ItemAction(data, index, fieldName)),
        updateGR_ItemAccountAssignment: (data, index, fieldName) => dispatch(updateGR_ItemAccountAssignmentAction(data, index, fieldName)),
        getPODetailOriginal: (poNo, unitCode, userId) => dispatch(getPODetailOriginalAction(poNo, unitCode, userId)),
        getDataReleaseOrder: (poNo, itemNo) => dispatch(getDataReleaseOrderAction(poNo, itemNo)),
        getDetailLogBOT: (transaction_no) => dispatch(getDetailLogBOTAction(transaction_no)),
        
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DetailBotLogModal) 